import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { Multitenant } from '../../../services/multitenant.provider';

@Component({
  selector: 'app-one-per-week',
  templateUrl: 'one-per-week.html',
  styleUrls: ['one-per-week.scss']
})
export class OnePerWeekComponent implements OnInit {
  @Input() public show: boolean;
  @Output() notify: EventEmitter<string> = new EventEmitter<string>();

  private themeClass: string;

  constructor(private multiTenant: Multitenant, private router: Router) { }

  ngOnInit() {
    this.themeClass = this.multiTenant.getDomainClass();
  }

  goToLogin() {
    this.show = false;
    this.notify.emit('closed');
    this.router.navigate(['connexion']);
  }

  goToBoutique() {
    if (this.themeClass === 'lepq') {
      const cucu = Math.floor(Math.random() * 2 + 1);
      const jan1 = new Date(2018, 0, 1);
      const currentDate = new Date();

      if (cucu === 1 || jan1 < currentDate) {
        window.open('https://www.playbacpresse.fr/abonnements-le-petit-quotidien', '_blank');
      } else {
        this.router.navigate(['offres']);
      }
    } else if (this.themeClass === 'mquo') {
      window.open('https://www.playbacpresse.fr/abonnements-mon-quotidien', '_blank');
    } else if (this.themeClass === 'actu') {
      window.open('https://www.playbacpresse.fr/abonnements-l-actu', '_blank');
    } else if (this.themeClass === 'aeco') {
      window.open('https://www.playbacpresse.fr/abonnements-l-eco', '_blank');
    } else {
      window.open('https://www.playbacpresse.fr', '_blank');
    }
  }
}
